 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		16: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		16: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"18389ac5eacc5ba68c2053858d81c8647af01c3f","2":"f08a028ccab136bf00436aec139f88f0fa019d86","3":"0ce814af0a3dfb2d1442d0ca9204ba375f1a53e0","4":"97c907ce537b7cbdfa41f556182f2750ff685301","5":"c304476c375035fe5ab57f96826d1ad6ff657af5","6":"4c355f13","7":"c05b8182","8":"component---src-pages-layout-js","9":"152025db965c661bb24971169d0795fbb208a411","10":"bf8ae653ceedbcb9aee81fe0aff53ae73c0db6ef","11":"3f985f62e6c52f7e8bc97d6e9a76b184f2711dc4","12":"b9b041f39dc3568dd313b944196020ea562c7d57","13":"bc62dab504a71ef8c5d240a105694d09627f06f3","14":"component---src-pages-integration-builder-sections-code-tsx","15":"d5ceeaead26c68f645dc39122ccc1b9861fd8433","17":"11e8d57d","19":"5cf42e9e","20":"5d19cfc4","21":"962beaf7","23":"component---src-pages-404-js","24":"component---src-pages-banner-js","25":"component---src-pages-build-better-js","26":"component---src-pages-classic-home-js","27":"component---src-pages-docs-template-js","28":"component---src-pages-home-js","29":"component---src-pages-index-js","30":"component---src-pages-integration-builder-index-tsx","31":"component---src-pages-integration-builder-sections-build-tsx","32":"component---src-pages-integration-builder-sections-card-generator-tsx","33":"component---src-pages-integration-builder-sections-configure-tsx","34":"component---src-pages-integration-builder-sections-demo-tsx","35":"component---src-pages-integration-builder-sections-help-modal-tsx","36":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","37":"component---src-pages-integration-builder-sections-preview-tsx","38":"component---src-pages-integration-builder-sections-take-live-tsx","39":"component---src-pages-internal-js","40":"component---src-pages-signup-js","41":"component---src-pages-signupauto-js","42":"component---src-pages-support-js","43":"component---src-pages-thankyou-js","44":"component---src-pages-unsubscribe-js","45":"component---src-pages-video-collection-tsx","46":"component---src-pages-video-home-tsx","47":"component---src-pages-video-watch-tsx","48":"component---src-templates-template-layout-js","49":"d7eeaac4"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"a20e9775fd6710d8e205","2":"1c7b69f213d7c3986414","3":"104e309ac120c3808e52","4":"79841b47e6190bd2d08f","5":"34b8612141ef90d24954","6":"4b915c8dce7e8a0d67dc","7":"e5097453ee6a50d8ccf3","8":"f6ea723e7ac146a82066","9":"15d3e1eb57518d9b303f","10":"66c3e65e74cf7f504525","11":"e5cc3ef004982b6b5622","12":"8d165a362177c53bccbf","13":"c046aa84c6e421819780","14":"9d14e43c88f2e2217f55","15":"35a2620bf54fcd138069","17":"59415f4528721ef06e6b","19":"743bfb2f642487c7f892","20":"64cf45a5817ea34b4e33","21":"4c99f22758ef71b2808e","23":"158ec7163501a889f87a","24":"ada406f27b39066f4dea","25":"3a5acc5cb818672e9103","26":"3cd2b3020bb4cfe6b119","27":"b98a771741640637a47a","28":"510ec03d83ec12326cf0","29":"77f191817f8cf756258d","30":"6a56b8e5a496f7c2c4dc","31":"f6a80e9716f0db9792a1","32":"063345c64ff5483e900d","33":"97d8de33ea24ec033dad","34":"70fc5b73e5ff6047a6e2","35":"bad4063136dec2c539a6","36":"d0ff58ea8e052561fd6e","37":"4c7a973592397c1677ae","38":"fad333ab91bb7beec842","39":"7720a22294a978d69f2c","40":"881087a3f71ad98d3a02","41":"a88fe9927beef78b2357","42":"d9ecae24c68fbf3c30fc","43":"4d55482bbc27a8446840","44":"54c4e5bbfce4a3be9bba","45":"0f72d1ef3b59a0a88bb6","46":"86c6a793c37bad6fc90f","47":"30553ed3eebf61ec3e0d","48":"58c26d1942d3a07200b6","49":"351309928cb5d18f2056"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"18389ac5eacc5ba68c2053858d81c8647af01c3f","2":"f08a028ccab136bf00436aec139f88f0fa019d86","3":"0ce814af0a3dfb2d1442d0ca9204ba375f1a53e0","4":"97c907ce537b7cbdfa41f556182f2750ff685301","5":"c304476c375035fe5ab57f96826d1ad6ff657af5","6":"4c355f13","7":"c05b8182","8":"component---src-pages-layout-js","9":"152025db965c661bb24971169d0795fbb208a411","10":"bf8ae653ceedbcb9aee81fe0aff53ae73c0db6ef","11":"3f985f62e6c52f7e8bc97d6e9a76b184f2711dc4","12":"b9b041f39dc3568dd313b944196020ea562c7d57","13":"bc62dab504a71ef8c5d240a105694d09627f06f3","14":"component---src-pages-integration-builder-sections-code-tsx","15":"d5ceeaead26c68f645dc39122ccc1b9861fd8433","17":"11e8d57d","19":"5cf42e9e","20":"5d19cfc4","21":"962beaf7","23":"component---src-pages-404-js","24":"component---src-pages-banner-js","25":"component---src-pages-build-better-js","26":"component---src-pages-classic-home-js","27":"component---src-pages-docs-template-js","28":"component---src-pages-home-js","29":"component---src-pages-index-js","30":"component---src-pages-integration-builder-index-tsx","31":"component---src-pages-integration-builder-sections-build-tsx","32":"component---src-pages-integration-builder-sections-card-generator-tsx","33":"component---src-pages-integration-builder-sections-configure-tsx","34":"component---src-pages-integration-builder-sections-demo-tsx","35":"component---src-pages-integration-builder-sections-help-modal-tsx","36":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","37":"component---src-pages-integration-builder-sections-preview-tsx","38":"component---src-pages-integration-builder-sections-take-live-tsx","39":"component---src-pages-internal-js","40":"component---src-pages-signup-js","41":"component---src-pages-signupauto-js","42":"component---src-pages-support-js","43":"component---src-pages-thankyou-js","44":"component---src-pages-unsubscribe-js","45":"component---src-pages-video-collection-tsx","46":"component---src-pages-video-home-tsx","47":"component---src-pages-video-watch-tsx","48":"component---src-templates-template-layout-js","49":"d7eeaac4"}[chunkId]||chunkId) + "." + {"0":"2fbae2b2e61493249484","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.paypalobjects.com/ppdevdocs/v2noapi/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
